(() => {
  'use strict';

  // Guard against double-initialization (two sections may load this asset).
  if (window.__themeNewsletterValidationInit) return;
  window.__themeNewsletterValidationInit = true;

  const FORM_SELECTOR = '[data-newsletter-validate]';
  const ERROR_SELECTOR = '[data-newsletter-client-error]';
  // Requires local@domain.tld — HTML5 type=email alone accepts "name@host" (no TLD).
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const getEmailInput = (form) => form.querySelector('input[type="email"]');
  const getErrorEl = (form) => form.querySelector(ERROR_SELECTOR);

  const showError = (form, input, errorEl) => {
    input.setAttribute('aria-invalid', 'true');
    if (errorEl) {
      errorEl.hidden = false;
      if (errorEl.id) input.setAttribute('aria-describedby', errorEl.id);
    }
  };

  const clearError = (form, input, errorEl) => {
    input.removeAttribute('aria-invalid');
    if (errorEl) errorEl.hidden = true;
  };

  const validate = (form) => {
    const input = getEmailInput(form);
    if (!input) return true;
    const value = input.value.trim();
    const errorEl = getErrorEl(form);
    if (!EMAIL_RE.test(value)) {
      showError(form, input, errorEl);
      return false;
    }
    clearError(form, input, errorEl);
    return true;
  };

  // Capture phase so we can block submission before it navigates.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;
      if (!validate(form)) {
        event.preventDefault();
        const input = getEmailInput(form);
        if (input) input.focus();
      }
    },
    true
  );

  // Clear the error as soon as the visitor edits the field.
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'email') return;
    const form = input.closest(FORM_SELECTOR);
    if (!form) return;
    const errorEl = getErrorEl(form);
    if (errorEl && !errorEl.hidden) clearError(form, input, errorEl);
  });
})();
